import emailjs from '@emailjs/browser';

// EmailJS configuration
const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

/**
 * Send email notification for new lead submission
 * @param {Object} leadData - The lead information
 * @returns {Promise} - EmailJS response
 */
export const sendLeadNotification = async (leadData) => {
    // Check if EmailJS is configured
    if (!EMAILJS_SERVICE_ID || !EMAILJS_TEMPLATE_ID || !EMAILJS_PUBLIC_KEY) {
        console.warn('EmailJS not configured. Skipping email notification.');
        console.warn('Missing keys:', {
            serviceId: !!EMAILJS_SERVICE_ID,
            templateId: !!EMAILJS_TEMPLATE_ID,
            publicKey: !!EMAILJS_PUBLIC_KEY
        });
        return { success: false, message: 'EmailJS not configured' };
    }

    // valid public key format? usually 'user_...' or similar string
    try {
        emailjs.init({
            publicKey: EMAILJS_PUBLIC_KEY,
        });
    } catch (initErr) {
        console.warn('EmailJS init failed:', initErr);
    }

    console.log('Attempting to send email notification...');

    try {
        // Format the data for the email template
        const templateParams = {
            name: leadData.name,
            email: leadData.email,
            phone: leadData.phone || 'Not provided',
            client_type: leadData.client_type || 'N/A',
            services: Array.isArray(leadData.services)
                ? leadData.services.join(', ')
                : 'Not specified',
            message: leadData.message || 'No message provided',
            form_source: leadData.form_source === 'contact_page'
                ? 'Contact Page'
                : 'Enquiry Modal',
            submission_time: new Date().toLocaleString('en-IN', {
                timeZone: 'Asia/Kolkata',
                dateStyle: 'full',
                timeStyle: 'long'
            }),
            to_email: 'primesolutions108@gmail.com'
        };

        // Send email using EmailJS
        const response = await emailjs.send(
            EMAILJS_SERVICE_ID,
            EMAILJS_TEMPLATE_ID,
            templateParams,
            EMAILJS_PUBLIC_KEY
        );

        console.log('Email sent successfully:', response);
        return { success: true, response };
    } catch (error) {
        console.error('Failed to send email:', error);
        return { success: false, error: error.message };
    }
};
